<template>
    <div class="layout-page">
        <div class="summary-container">
            <div class="summary-info">
                <div class="bills-generated">
                    <div class="title">{{ $t('customers.clients') }}</div>
                    <div class="number">{{ kpis.customers }}</div>
                </div>

                <div class="bills-generated">
                    <div class="title">{{ $t('bills.import') }}</div>
                    <div class="number">{{ kpis.import.toFixed(2) + '€' }}</div>
                </div>
            </div>

            <div class="summary-actions">
                <FilterCustomers
                    v-on:applyFilters="onApplyFilters"
                    v-on:resetFilters="onResetFilters"
                ></FilterCustomers>

                <div class="table-actions">
                    <div class="export">
                        <div class="export-button" @click="exportButton = !exportButton">
                            {{ selected.length > 0 ? $t('bills.export') : $t('bills.export_all') }}
                        </div>

                        <transition name="fade">
                            <div class="export-box" v-if="exportButton">
                                <div class="text" @click="downloadPDF()">{{ $t('bills.export_as_pdf') }}</div>
                                <div class="text" @click="downloadEXCEL()">{{ $t('bills.export_as_xlsx') }}</div>
                                <div class="text" @click="downloadXML()">{{ $t('bills.export_as_xml') }}</div>
                            </div>
                        </transition>
                    </div>

                    <div class="search">
                        <input
                            type="text"
                            v-model="search"
                            class="input-search"
                            name="name"
                            @input="onSearchInput"
                            placeholder="Buscar..."
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="data-table">
            <v-data-table
                v-if="items"
                v-model="selected"
                :headers="headers"
                :items="items"
                fixed-header
                sort-by="name"
                :sort-asc="true"
                hide-default-footer
                show-select
                disable-pagination
                :items-per-page="-1"
            >
                <template #item.customer_cif="item">
                    <div class="ticket">{{ item.item.customer_cif }}</div>
                </template>

                <template #item.name="item">
                    <div class="row">{{ item.item.name }}</div>
                </template>

                <template #item.import="item">
                    <div class="row">{{ parseFloat(item.item.import).toFixed(2) + '€' }}</div>
                </template>

                <template #item.bills="item">
                    <div class="row">{{ item.item.bills }}</div>
                </template>

                <template #item.id="item">
                    <div class="row-image">
                        <img class="icon" @click="exportPDF(item.item.customer_cif)" src="../../public/img/pdf_icon.svg" />
                    </div>
                </template>

                <template v-slot:no-data>
                    <div class="no-data">{{ $t('bills.table_no_data') }}</div>
                </template>
            </v-data-table>

            <div id="pagination">
                <div class="totalItems">
                    <span class="total">
                        <strong class="total-results">{{ meta.total_customers }}</strong>
                        {{ $tc('bills.results', meta.total_customers) }}
                    </span>
                </div>

                <v-pagination
                    v-model="page"
                    color="#C4C4C4"
                    :length="meta.total_pages"
                    :total-visible="maxPageVisibles"
                    @input="onPageChange"
                ></v-pagination>
                
                <div class="rows-page">
                    <v-select
                        :items="rowsPerPage"
                        :label="nRegistros"
                        v-model="perPage"
                        @change="onPerPageChange"
                    ></v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterCustomers from '../components/layout/admin/customers/Filter.vue'

export default {
    components: { FilterCustomers },
    name: 'Customers',
    data() {
        return {
            exportButton: false,
            selected: [],
            allSelected: false,
            search: '',
            page: 1,
            perPage: 20,
            rowsPerPage: [10, 20, 50],
            maxPageVisibles: 10,
            searchTimer: null,
        }
    },
    computed: {
        items() {
            return this.$store.getters['customers/getCustomers']()
        },
        meta() {
            return this.$store.getters['customers/getCustomersMeta']
        },
        kpis() {
            return this.$store.getters['customers/getCustomersKpis']
        },
        headers() {
            return [
                { text: this.$t('customers.fiscal_id'), align: 'start', sortable: true, value: 'customer_cif', class: 'header-table' },
                { text: this.$t('customers.name'), value: 'name', sortable: true, class: 'header-table' },
                { text: this.$t('customers.total_import'), value: 'import', align: 'start', sortable: true, class: 'header-table' },
                { text: this.$t('customers.bill'), value: 'bills', align: 'start', sortable: false, class: 'header-table' },
                { text: '', value: 'id', align: 'start', width: '40px', sortable: false, class: 'header-table' }
            ]
        },
        nRegistros() {
            let letter = this.$t('bills.show_bills').toString()
            return letter.replace(' ', ' ' + this.perPage + ' ')
        },
    },
    methods: {
        async loadPage() {
            const filters = { ...this.$store.getters['customers/getCustomersFiltersActive'] }

            const params = {
                ...filters,
                page: this.page,
                per_page: this.perPage,
                search: this.search || ''
            }

            if (params.customers === 'admin.filters.all_customers') params.customers = ''
            if (params.date === undefined) params.date = 'month'

            this.$overlay.show()
            await this.$store.dispatch('customers/loadCustomers', params)
            this.$overlay.hide()
        },

        onApplyFilters() {
            this.page = 1
            this.selected = []
            this.exportButton = false
            this.loadPage()
        },

        onResetFilters() {
            this.page = 1
            this.selected = []
            this.exportButton = false
            this.search = ''
            this.loadPage()
        },

        onPageChange() {
            this.selected = []
            this.exportButton = false
            this.loadPage()
        },

        onPerPageChange() {
            this.page = 1
            this.selected = []
            this.exportButton = false
            this.loadPage()
        },

        onSearchInput() {
            clearTimeout(this.searchTimer)

            this.searchTimer = setTimeout(() => {
                this.page = 1
                this.selected = []
                this.exportButton = false
                this.loadPage()
            }, 350)
        },

        downloadPDF() {
            const parameters = {}
            const filtersActive = this.$store.getters['customers/getCustomersFiltersActive']

            if (this.selected.length === 0 || this.allSelected) {
                parameters.all = 1
            } else {
                const ids = this.selected.map((x) => x.customer_cif)
                parameters.customers = ids.toString()
            }

            if (filtersActive.customers != 'admin.filters.all_customers') {
                parameters.customers = filtersActive.customers
            }

            if (typeof filtersActive.date !== 'undefined') parameters.date = filtersActive.date
            if (typeof filtersActive.start_date !== 'undefined') parameters.start_date = filtersActive.start_date
            if (typeof filtersActive.end_date !== 'undefined') parameters.end_date = filtersActive.end_date

            this.$overlay.show()
            const self = this
            this.$store.dispatch('customers/downloadPDF', parameters).then(function (response) {
                self.exportButton = false
                self.$overlay.hide()
                window.open(response, 'blank')
            })
        },

        exportPDF(id) {
            const filtersActive = this.$store.getters['customers/getCustomersFiltersActive']
            const params = { customers: id, all: 0 }
            if (typeof filtersActive.date !== 'undefined') params.date = filtersActive.date

            this.$overlay.show()
            const self = this
            this.$store.dispatch('customers/downloadPDF', params).then(function (response) {
                self.$overlay.hide()
                window.open(response, 'blank')
            })
        },

        downloadEXCEL() {
            const parameters = {}
            const filtersActive = this.$store.getters['customers/getCustomersFiltersActive']

            if (this.selected.length === 0 || this.allSelected) {
                parameters.all = 1
            } else {
                const ids = this.selected.map((x) => x.customer_cif)
                parameters.customers = ids.toString()
            }

            if (filtersActive.customers != 'admin.filters.all_customers') {
                parameters.customers = filtersActive.customers
            }

            if (typeof filtersActive.date !== 'undefined') parameters.date = filtersActive.date
            if (typeof filtersActive.start_date !== 'undefined') parameters.start_date = filtersActive.start_date
            if (typeof filtersActive.end_date !== 'undefined') parameters.end_date = filtersActive.end_date

            this.$overlay.show()
            const self = this
            this.$store.dispatch('customers/downloadEXCEL', parameters).then(function (response) {
                self.exportButton = false
                self.$overlay.hide()
                window.open(response, 'blank')
            })
        },

        downloadXML() {
            const parameters = {}
            const filtersActive = this.$store.getters['customers/getCustomersFiltersActive']

            if (this.selected.length === 0 || this.allSelected) {
                parameters.all = 1
            } else {
                const ids = this.selected.map((x) => x.customer_cif)
                parameters.customers = ids.toString()
            }

            if (filtersActive.customers != 'admin.filters.all_customers') {
                parameters.customers = filtersActive.customers
            }

            if (typeof filtersActive.date !== 'undefined') parameters.date = filtersActive.date
            if (typeof filtersActive.start_date !== 'undefined') parameters.start_date = filtersActive.start_date
            if (typeof filtersActive.end_date !== 'undefined') parameters.end_date = filtersActive.end_date

            this.$overlay.show()
            const self = this
            this.$store.dispatch('customers/downloadXML', parameters).then((response) => {
                self.exportButton = false
                self.$overlay.hide()
                const url = typeof response === 'string' ? response : (response && response.data) ? response.data : null
                if (url) {
                    const token = localStorage.getItem('token')
                    fetch(url, {
                        headers: token ? { Authorization: token } : {}
                    })
                        .then((res) => {
                            if (!res.ok) throw new Error('Descarga no disponible')
                            return res.blob()
                        })
                        .then((blob) => {
                            const blobUrl = URL.createObjectURL(blob)
                            const link = document.createElement('a')
                            link.href = blobUrl
                            link.download = 'sii_export.zip'
                            link.click()
                            URL.revokeObjectURL(blobUrl)
                        })
                        .catch(() => {})
                }
            })
        },
    },
    created() {
        this.$store.dispatch('customers/loadFiltersCustomers')
        this.loadPage()
    }
}
</script>

<style lang="scss">
.search {
    .input-search {
        background-image: url('../../public/img/searcher.svg');
    }
}
</style>
